import { env } from "configs/EnvironmentConfig";

export const API_BASE_URL = env.API_ENDPOINT_URL;
export const IMAGE_URL = env.IMAGE_URL;
export const PUBLIC_BLOG_BASE_URL = env.PUBLIC_BLOG_BASE_URL || "";
